export default {
  LOGISTIC:
    "LOGISTIC: Using the plate x, fit a regression with a dummy variable for the stadium. The coefficient for the dummy variable indicates how far left/right/up/down the strike zone is shifted compared to the rest of the league.",
  MIXED_MODEL:
    "MIXED MODEL: Fit mixed effects model predicting the plate x with the venue as a fixed effect. The assumption is that there should be no variation at the venue level that is significant from 0.",
  BINOMIAL:
    "BINOMIAL: Test to see what the expected probability of a strike call is. The assumption is that our average is 0.5. Very similar to the Beta-Binomial methodology without the prior."
};



// WEBPACK FOOTER //
// ./src/constants/modelDescriptions.js